module.exports = __webpack_public_path__ + "img/produce-1.b3f049ec.png";